import React from 'react';
import { useNavigate } from 'react-router-dom';
import LeaveRequestHistoryPage from './LeaveRequestHistoryPage';

const LeaveRequestHistoryPageWrapper = () => {
  const navigate = useNavigate();
  return <LeaveRequestHistoryPage navigate={navigate} />;
};

export default LeaveRequestHistoryPageWrapper;
